@for (notification of (notifications$ | async); track notification) {
  <div class="overlay">
    <div class="notification-card" [class.rtl]="notification.rtl">
      <div class="content">
        <h4>{{ notification.title }}</h4>
        <p [innerHTML]="notification.message"></p>
      </div>
      <button class="primary-btn" (click)="close(notification)">
        {{ notification.buttonText || 'OK' }}
      </button>
    </div>
  </div>
}